import React from "react";
import styled, { css } from "styled-components";
import settings from "../../settings";
import Humburger from "./Humburger";
import Logo from "../Logo";
import { down } from "styled-breakpoints";
import SpMenu from "./SpMenu";

export const Wrap = styled.div`
	display: flex;
	justify-content: center;
`;
export const Frame = styled.div<{ spMenuVisible: boolean }>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 112px;
	width: 100%;
	max-width: 1300px;
	padding: 0 2rem;
	& > ${Humburger} {
		display: none;
	}
	& > ${Logo} {
		transform: translateX(-3%);
	}
	& > ${SpMenu} {
		position: fixed;
		left: 0;
		bottom: 0;
		transition: transform 0.2s ease-out;
		${(props) =>
			props.spMenuVisible
				? css`
						transform: translateY(0%);
				  `
				: css`
						transform: translateY(100%);
				  `}
	}
	${down("lg")} {
		& > ${Humburger} {
			display: block;
		}
	}
	${down("md")} {
		padding: 2.5rem;
		height: auto;
	}
`;

export const Nav = styled.nav`
	display: flex;
	${down("lg")} {
		display: none;
	}
`;

export const NavItem = styled.a`
	font-size: 1rem;
	line-height: 1.2;
	font-weight: 500;
	color: ${settings.color.main};
	text-decoration: none;
	& + & {
		margin-left: 2rem;
	}
`;
